import { render, staticRenderFns } from "./ADetallePlanPagos.vue?vue&type=template&id=0a9688ff"
import script from "./ADetallePlanPagos.vue?vue&type=script&lang=js"
export * from "./ADetallePlanPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports